import * as Actions from "auth/store/actions";

const initialState = {
  successCheckToken: false,
  isCheckTokenLoading: false,
  errorCheckToken: null,
};

const checkTokon = (state = initialState, action) => {
  switch (action.type) {
    case Actions.CHECKTOKEN_START: {
      return {
        ...initialState,
        isCheckTokenLoading: true,
      };
    }
    case Actions.CHECKTOKEN_SUCCESS: {
      return {
        ...initialState,
        successCheckToken: true,
        isCheckTokenLoading: false,
      };
    }
    case Actions.CHECKTOKEN_ERROR: {
      return {
        successCheckToken: false,
        isCheckTokenLoading: false,
        errorCheckToken: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default checkTokon;
